<template>
  <v-card v-if="selectedSeat" :class="!isSmAndDown ? 'sector-card' : ''">
    <v-card-title>
      <v-layout justify-space-between row>
        <h2 class="checkout-h3">
          {{ getIdentification(selectedSeat) }}
          <v-icon
            small
            :color="selectedSeat.cor ? `${selectedSeat.cor}` : '#e0e0e0'"
            >brightness_1</v-icon
          >
          <span v-if="selectedSeat.tipo !== '9'" class="checkout-h3">
            {{ selectedSeat.nome_produto_vinculado }}
          </span>
        </h2>
        <v-spacer></v-spacer>
        <span
          v-if="!isSmAndDown"
          class="secondary--text link mt-1 cancel-btn"
          @click="cancelSelection"
          >Selecionar outro</span
        >
        <v-icon v-if="isSmAndDown" @click="cancelSelection">close</v-icon>
      </v-layout>
    </v-card-title>

    <v-layout v-if="seatProducts[0].observacoes">
      <div class="description-box">
        <v-flex>
          <v-layout>
            <h4 class="white--text">
              {{
                toggleMore[0]
                  ? seatProducts[0].observacoes
                  : cutString(seatProducts[0].observacoes)
              }}
            </h4>
          </v-layout>
          <v-layout>
            <h4
              v-if="seatProducts[0].observacoes.length > 42"
              class="checkout-h4 white--text clickable"
              style="font-weight: 500"
              @click.stop="toggleShowMore(0)"
            >
              {{ toggleMore[0] ? 'Mostrar menos' : 'Mostrar mais' }}
            </h4>
          </v-layout>
        </v-flex>
      </div>
    </v-layout>

    <v-divider></v-divider>
    <v-list three-lines class="sector-list py-0">
      <v-radio-group v-model="option">
        <template v-for="(product, index) in seatProducts">
          <v-layout
            justify-space-between
            row
            class="product-type-info"
            :key="`${product.codigo_produto} + ${index}`"
            @click="selectLine(product.codigo_tipo)"
          >
            <v-flex xs9 sm10 lg10>
              <h3 class="checkout-h3">{{ product.nome_tipo }}</h3>
              <h4
                class="product-price"
                v-html="productPriceDetails(product)"
              ></h4>
              <h4
                v-if="
                  selectedSeat.tipo === '9' && product.valor_consumacao_lote
                "
                class="product-price"
              >
                Inclui consumação de
                {{ (product.valor_consumacao_lote * 100) | currency }}
              </h4>
            </v-flex>
            <v-flex shrink>
              <v-layout>
                <div class="v-expansion-panel__header__icon">
                  <v-radio
                    :value="product.codigo_tipo"
                    color="#1976d2"
                  ></v-radio>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider :key="index"></v-divider>
        </template>
      </v-radio-group>
    </v-list>

    <v-footer app height="80" v-if="isSmAndDown" class="bg-footer-sector">
      <v-layout class="px-4">
        <v-btn
          block
          round
          depressed
          class="normal-text"
          :color="option ? 'primary' : 'info'"
          :disabled="!option"
          :loading="loading"
          @click="selectType"
          >Adicionar ao carrinho</v-btn
        >
      </v-layout>
    </v-footer>
    <v-footer class="desktop-footer" height="60" v-if="!isSmAndDown">
      <v-layout class="px-4">
        <v-btn
          block
          round
          depressed
          class="normal-text"
          :color="option ? 'primary' : 'info'"
          :disabled="!option"
          :loading="loading"
          @click="selectType"
          >Adicionar ao carrinho</v-btn
        >
      </v-layout>
    </v-footer>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      option: null,
      prevProduct: null,
      toggleMore: [],
      loading: false,
    };
  },
  mounted() {},

  filters: {
    getNumber: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').pop();
    },
    getRow: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').shift();
    },
  },
  computed: {
    ...mapGetters({
      sector: 'selectedSector',
      selectedSeat: 'selectedSeat',
      eventName: 'eventName',
      eventID: 'eventID',
      eventDetails: 'eventDetails',
    }),
    seatProducts() {
      let selectedSector = this.$store.getters.selectedSector.products;
      let selectedSeat = this.selectedSeat;
      let seatProducts = selectedSector.filter(
        sc => sc.codigo_produto === selectedSeat.produto_vinculado
      );
      return seatProducts;
    },
  },
  methods: {
    cutString(data) {
      if (data.length > 42) return `${data.substring(0, 39)}...`;
      return data;
    },
    toggleShowMore(i) {
      this.$set(this.toggleMore, i, !this.toggleMore[i]);
    },
    selectLine(codigo) {
      this.option = codigo;
    },
    cancelSelection() {
      this.selectedSeat.selecionado = false;
      this.$store.dispatch('setCanceledSeat', this.selectedSeat);
      this.$store.commit('SET_SELECTED_SEAT', null);
    },
    async selectType() {
      this.loading = true;
      let product = this.seatProducts.filter(
        el => el.codigo_tipo === this.option
      );

      this.selectedSeat.op = true;
      this.selectedSeat.reserved = true;
      let checkReturn = await this.$store.dispatch(
        'setSelectedSeat',
        this.selectedSeat
      );
      if (checkReturn.success && product[0] && this.selectedSeat) {
        product[0].codigo_obj = this.selectedSeat.codigo_obj;
        product[0].codigo_assento = this.selectedSeat.codigo_assento;
        if (!product[0].seat_id) product[0].seat_id = [];
        product[0].seat_id.push(this.selectedSeat.identificacao);
        product[0].reserved = true;
        this.add(product[0]);
        await this.$store.commit('SET_SELECTED_SEAT', null);
      } else {
        this.$store.dispatch('openSnackbar', {
          message: 'Erro ao reservar, assento indisponível.',
        });
        this.selectedSeat.disponivel = false;
        this.selectedSeat.selecionado = false;
        this.$store.commit('SET_SELECTED_SEAT', null);
      }
      this.loading = false;
    },
    add(product) {
      product.haveSeat = true;
      this.$store.dispatch('addCartProduct', product);
      this.$store.dispatch('incrementProductsQuantity', product);
    },
    remove(product) {
      product.haveSeat = true;
      this.$store.dispatch('removeCartProduct', product);
      this.$store.dispatch('decrementProductsQuantity', product);
    },
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor * 100);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia * 100
          )} taxa`
        : '';
      const lote = ` (Lote ${product.lote})`;
      if (product.cupom === 0)
        return `<span style="font-size: 16px; color: #1976d2">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
      else
        return `<span style="font-size: 16px; color: #00A65A">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
    },
    getIdentification(seat) {
      const { identificacao } = seat;

      let stringIdentification = String(identificacao);

      let formatted = stringIdentification.replace('Mesa', '');

      if (stringIdentification.includes('Mesa')) {
        if (seat.class === 'cadeira')
          return (
            'Mesa ' +
            formatted.split(';')[0] +
            ' Cadeira ' +
            formatted.split(';').pop()
          );
        else return 'Mesa ' + formatted;
      } else if (stringIdentification.includes('MESA')) {
        if (seat.class === 'cadeira') return '';
        else return 'Mesa ' + formatted.split('-')[1];
      }

      return (
        this.getRowMethod(stringIdentification) +
        ` ${this.getNumberMethod(stringIdentification)}`
      );
    },
    getNumberMethod(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').pop();
    },
    getRowMethod(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').shift();
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
}
.desktop-footer {
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: white;
}

.description-box {
  background-color: orange;
  padding: 10px;
  margin-left: 16px;
  margin-bottom: 16px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cancel-btn {
  cursor: pointer;
}
.sector-card {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 80vh !important;
}
::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #c8ccd3;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #aeb5be;
}
</style>
<style lang="stylus">
@import '~@/assets/product/productsPanel.styl'
@import "~@/assets/product/productTypes.styl"
</style>
